import { useAuthorization } from "@/shared/hooks/useAuthorization"
import { ErrorComponent } from "../../ErrorComponent/ErrorComponent"
import { Loading } from "../../Loading/Loading"
import { AuthorizedRouter } from "../AuthorizedRouter"
import { UnauthorizedRouter } from "../UnauthorizedRouter"

export function AuthenticatedRouter() {
  const { isLoading, isUnauthorized, isError, error, retry } = useAuthorization()
  if (isLoading) {
    return <Loading />
  }

  if (isError) {
    return <ErrorComponent onRetry={() => void retry()} error={error} />
  }

  return isUnauthorized ? <UnauthorizedRouter /> : <AuthorizedRouter />
}
